import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { Person } from '../../../models/Entities/Person/Person';

// store
import * as PersonsStore from '../../../redux/middleware/Persons.Middleware';
import * as StaffStore from '../../../redux/middleware/Staff.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  /**
   * Miembro del staff que se está editando. Es lo que distingue alta de
   * modificación, y no la persona: al abrir para editar la persona todavía no
   * llegó, y sin esto el primer instante del formulario se leería como un alta.
   */
  staffId?: number | undefined;
  /** Persona detrás de ese miembro, de donde salen los datos del formulario. */
  personId?: number | undefined;
}

interface ConnectedProps {
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  isPersonLoading: boolean | undefined;
  error: ErrorType | undefined;
  person?: Person;
}

interface DispatchProps {
  CreateStaff: typeof StaffStore.actionCreators.CreateStaff;
  UpdateStaff: typeof StaffStore.actionCreators.UpdateStaff;
  GetPersonById: typeof PersonsStore.actionCreators.GetPersonById;
}

export type Props = IProps & ConnectedProps & DispatchProps;

/**
 * El alta y la modificación viajan por la API de staff, que es la dueña de la
 * incorporación; los datos que el formulario edita son de la persona y se leen de
 * la API de personas, porque la de staff no los publica.
 */
export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isAdding: state.Staff?.isAddingNewOne,
  successAdding: state.Staff?.successAddingNewOne,
  failAdding: state.Staff?.failOnAddingNewOne,
  isUpdating: state.Staff?.isUpdatingOne,
  successUpdating: state.Staff?.successUpdatingOne,
  failUpdating: state.Staff?.failOnUpdatingOne,
  isPersonLoading: state.Persons?.isLoadingOne,
  error: state.Staff?.error ?? state.Persons?.error,
  person: state.Persons?.list.find((item: Person) => item.id === ownProps.personId),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonsStore.actionCreators,
  ...StaffStore.actionCreators
};
